import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Container, Table, CollapseStyled } from './styles';
import { useAuth } from '../../hooks/auth';
import { useParams } from 'react-router-dom';
import Api, { exceptionNotificationAPI } from '../../services/api';
import Select from 'react-select';
import TableLoading from '../../components/TableLoading/index';
import { error_message } from '../../components/Toast/index.jsx';
import { AiFillFileWord, AiFillFilePdf, AiFillFileExcel, AiFillFileImage } from "react-icons/ai";
import { FaArrowRight, FaAngleDown, FaAngleUp, FaArrowUp, FaArrowDown, FaFileAlt } from 'react-icons/fa';
import GetTypeInput from '../../components/FormInput/set';
import { NumericFormat } from 'react-number-format';
import ModalLoading from '../../components/ModalLoading/index';
import { formSelectStyles, formSelectControlFullWidth } from '../../components/FormInput/formSelectStyles';

const VersionComparison = () => {
    const { user } = useAuth();
    const { companyID, reportYearID, operationID, moduleID } = useParams();
    const [userObject, setUserObject] = useState(null);
    const [loading, setLoading] = useState(true);

    const [cultureID] = useState(localStorage.getItem('@Thrive:cultureID'));

    //Company Select Variables
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(companyID);

    //Operation Select Variables
    const [operations, setOperations] = useState([]);
    const [selectedOperation, setSelectedOperation] = useState(operationID);

    //Module Select Variables
    const [modules, setModules] = useState([]);
    const [modulesFiltered, setModulesFiltered] = useState([]);
    const [selectedModule, setSelectedModule] = useState(moduleID);

    //Crop Year Select Variables
    const [cropYears, setCropYears] = useState([]);
    const [selectedReportYear, setSelectedReportYear] = useState(reportYearID);
    const [selectedReportYearOne, setSelectedReportYearOne] = useState(reportYearID);
    const [selectedReportYearTwo, setSelectedReportYearTwo] = useState(reportYearID);

    //Version Select Variables
    const [versionsSelectOne, setVersionsSelectOne] = useState([]);
    const [versionsSelectTwo, setVersionsSelectTwo] = useState([]);

    //Checkbox Data Changed Variables
    const [showJustDataChanged, setShowJustDataChanged] = useState(true);

    //Checkbox just inputs
    const [showJustInput, setShowJustInput] = useState(false);

    //Ref Number Select Variables
    const [refNumberSelect, setRefNumberSelect] = useState([]);
    const [selectedRefNumber, setSelectedRefNumber] = useState(null);

    //Culture Types Select Variables
    const [cultureTypes, setCultureTypes] = useState([]);
    const [selectedCultureType, setSelectedCultureType] = useState(null);

    //Load Table Versions
    const [selectedVersionOne, setSelectedVersionOne] = useState(null);
    const [selectedVersionTwo, setSelectedVersionTwo] = useState(null);
    const [selectedVersionNumberOne, setSelectedVersionNumberOne] = useState(null);
    const [selectedVersionNumberTwo, setSelectedVersionNumberTwo] = useState(null);
    const [loadingView, setLoadingView] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [viewSpecificData, setViewSpecificData] = useState(null);
    const [loadingFile, setLoadingFile] = useState(false);
    const [isFirstLoading, setIsFirstLoading] = useState(false);
    const [selectedCompanyIsSourcingGroup, setSelectedCompanyIsSourcingGroup] = useState(true);
    const [compareYear, setCompareYear] = useState(false);
    var yearTarget = null;

    const pendingOpLoadOptsRef = useRef({});

    useEffect(() => {
        var userAux = typeof (user) == "string" ? JSON.parse(user) : user;
        setUserObject(userAux);

        if (!userAux.companyID || userAux.groupID) {
            loadCompanies(userAux.groupID);
        } else {
            setSelectedCompany(userAux.companyID);
        }

        loadCropYears(userAux);
    }, []);

    useEffect(() => {

        if (!compareYear) {
            if (selectedModule && selectedCompany && selectedReportYear) {
                if (modulesFiltered.find(x => x.moduleID == selectedModule)?.moduleExternalID == 15000) {
                    if (selectedCultureType) {
                        loadVersions();
                    }
                }
                else {
                    loadVersions();
                }
            }
            setSelectedVersionOne(null);
            setVersionsSelectTwo([]);
        } else {
            if (selectedModule && selectedCompany && selectedReportYearOne) {
                if (modulesFiltered.find(x => x.moduleID == selectedModule)?.moduleExternalID == 15000) {
                    if (selectedCultureType) {
                        loadVersionsCompareYear(true);
                    }
                }
                else {
                    loadVersionsCompareYear(true);
                }
            }
        }


    }, [selectedModule, selectedCompany, selectedOperation, selectedReportYear, selectedCultureType, selectedReportYearOne, compareYear]);


    /*
    useEffect(() => {
        if (selectedCompany) {
            Api.get(`ThriveValue/CheckIfSupplierIsSourcingGroup?companyID=${selectedCompany}`)
                .then((result) => {
                    if (result && result.data) {
                        setSelectedCompanyIsSourcingGroup(result.data.response);

                        ///loadModules(result.data.response);
                    }
                }).catch((error) => {
                    exceptionNotificationAPI(error);
                });
        }

    }, [selectedCompany])
    */
    useEffect(() => {
        if (selectedCompany && selectedReportYear) {
            Api.get(`CultureType/GetSelectedCultureTypes?companyID=${selectedCompany}&reportYearID=${selectedReportYear}`)
                .then((result) => {
                    if (result && result.data) {
                        setCultureTypes([...result.data.response]);
                    }
                }).catch((error) => {
                    exceptionNotificationAPI(error);
                });
        } else {
            setCultureTypes([]);
            setSelectedCultureType(null);
        }
    }, [selectedCompany, selectedReportYear])

    const loadCompanies = (groupID = null) => {
        if (groupID != null) {
            Api.get(`Dashboard/getAllCompaniesFilteredByGroup`).then((result) => {
                if (result && result.data) {
                    setCompanies(result.data.response);
                    // setSelectedCompanyIndex([0]);
                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        }
        else {
            Api.get(`Company/getAllByCulture?cultureID=${cultureID}`).then((result) => {
                if (result && result.data) {
                    setCompanies(result.data.response);

                    if (companyID)
                        setSelectedCompany(companyID);
                    else
                        setSelectedCompany(result.data.response[0].companyID);
                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        }
    }

    const loadCropYears = (userAux) => {
        Api.get(`thriveValue/getAllCropsYears?selectedCulture=${cultureID}`).then((result) => {
            if (result && result.data) {
                setCropYears(result.data.response);

                if (reportYearID) {
                    setSelectedReportYear(reportYearID);
                    setSelectedReportYearOne(reportYearID);
                    setSelectedReportYearTwo(reportYearID);
                }
                else if (userAux != null) {
                    setSelectedReportYear(userAux.selectedReportYearID);
                    setSelectedReportYearOne(userAux.selectedReportYearID);
                    setSelectedReportYearTwo(userAux.selectedReportYearID);
                }
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const loadOperations = (reportYearID, companyIdOverride, opts = {}) => {
        const { clearFormAndModule = false } = opts;
        const cid = companyIdOverride !== undefined ? companyIdOverride : selectedCompany;
        if (cid === undefined || cid === null || cid === '') {
            return;
        }
        if (reportYearID === undefined || reportYearID === null || reportYearID === '') {
            return;
        }
        const qs = `reportYearID=${encodeURIComponent(reportYearID)}&companyID=${encodeURIComponent(cid)}`;
        Api.get(`thriveValue/getAllOperationsByReportYear?${qs}`).then((result) => {
            if (result && result.data) {

                let response = result.data.response;
                let firstOp = '';
                if (response.length > 0) {
                    setOperations(response);
                    firstOp = response[0].operationID;
                    if (!clearFormAndModule) {
                        setSelectedOperation(firstOp);
                    } else {
                        setSelectedOperation('');
                    }
                } else {
                    response.push({
                        operationID: "",
                        description: `No items found, please select another Report Year`,
                    })
                    setOperations(response);
                    setSelectedOperation('');
                    setSelectedModule('');
                }

                setLoading(false);
                const opForModules = clearFormAndModule ? null : firstOp;
                loadModules(selectedCompanyIsSourcingGroup, reportYearID, cid, opForModules);
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const loadModules = (IsSourcingGroup, reportYearID, companyIdOverride, operationIdForFilter) => {
        const cid = companyIdOverride !== undefined ? companyIdOverride : selectedCompany;
        if (cid === undefined || cid === null || cid === '') {
            return;
        }
        const qs = `reportYearID=${encodeURIComponent(reportYearID)}&companyID=${encodeURIComponent(cid)}`;
        let opFilter;
        if (operationIdForFilter === null) {
            opFilter = null;
        } else if (operationIdForFilter !== undefined) {
            opFilter = operationIdForFilter;
        } else {
            opFilter = selectedOperation;
        }
        Api.get(`Dashboard/GetAllByReportYear?${qs}`).then((result) => {
            if (result && result.data) {
                const all = result.data.response;
                setModules(all);
                if (opFilter === null) {
                    setModulesFiltered([]);
                } else if (opFilter) {
                    if (!IsSourcingGroup) {
                        setModulesFiltered(all.filter(x => x.operationID == opFilter && x.description != "GLT"));
                    }
                    else {
                        setModulesFiltered(all.filter(x => x.operationID == opFilter));
                    }
                }
                else {
                    if (!IsSourcingGroup) {
                        setModulesFiltered(all.filter(x => x.description != "GLT"));
                    }
                    else {
                        setModulesFiltered(all);
                    }
                }
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    useEffect(() => {
        const reportYearForOps = compareYear ? selectedReportYearOne : selectedReportYear;
        if (selectedCompany === undefined || selectedCompany === null || selectedCompany === '') {
            return;
        }
        if (reportYearForOps === undefined || reportYearForOps === null || reportYearForOps === '') {
            return;
        }
        const opts = { ...pendingOpLoadOptsRef.current };
        pendingOpLoadOptsRef.current = {};
        loadOperations(reportYearForOps, selectedCompany, opts);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany, selectedReportYear, selectedReportYearOne, compareYear]);

    const onChangeCompany = (value) => {
        setSelectedCompany(value);
        setSelectedModule('');
        setSelectedCultureType(null);
        setSelectedRefNumber(null);
        const year = !compareYear ? selectedReportYear : selectedReportYearOne;
        if (year) {
            pendingOpLoadOptsRef.current = { clearFormAndModule: true };
        } else {
            setOperations([]);
            setSelectedOperation('');
            setModules([]);
            setModulesFiltered([]);
        }
    }

    const onChangeCropYear = (value) => {
        setSelectedReportYear(value);
    }

    const onChangeCropYearCompareYear = (value) => {
        setSelectedReportYearOne(value);
    }

    const onChangeOperation = (value) => {
        setSelectedModule('');
        var modulesAux = value != "" ? modules.filter(x => x.operationID == value) : modules;

        setSelectedOperation(value);
        setModulesFiltered(modulesAux);
    }

    const loadVersions = () => {
        Api.get(`thriveValue/getAllVersionsByModuleAndCompanyAndReportYear?selectedCompanyID=${selectedCompany}&moduleID=${selectedModule}&reportYearID=${selectedReportYear}${selectedCultureType != null ? '&cultureTypeID=' + selectedCultureType : ""}`).then((result) => {
            setVersionsSelectOne(result.data.response);

            if (companyID && reportYearID && operationID && moduleID && moduleID == selectedModule) {
                if (result.data.response.length > 1) {
                    var newestVersionIndex = (result.data.response.length - 1);
                    var versionOne = result.data.response[newestVersionIndex - 1] ? result.data.response[newestVersionIndex - 1].thriveValueVersionID : "";
                    var versionTwo = result.data.response[newestVersionIndex] ? result.data.response[newestVersionIndex].thriveValueVersionID : "";

                    setSelectedVersionOne(versionOne);
                    setSelectedVersionTwo(versionTwo);

                    setVersionsSelectTwo(result.data.response.filter(x => x.thriveValueVersionID != versionOne));
                }
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const loadVersionsCompareYear = (isOne = true, twoID = null) => {
        if (isOne) {
            Api.get(`thriveValue/getAllVersionsByModuleAndCompanyAndReportYear?selectedCompanyID=${selectedCompany}&moduleID=${selectedModule}&reportYearID=${selectedReportYearOne}${selectedCultureType != null ? '&cultureTypeID=' + selectedCultureType : ""}`).then((result) => {
                setVersionsSelectOne(result.data.response);
                if (companyID && reportYearID && operationID && moduleID && moduleID == selectedModule) {
                    if (result.data.response.length > 1) {
                        var newestVersionIndex = (result.data.response.length - 1);
                        var versionOne = result.data.response[newestVersionIndex - 1] ? result.data.response[newestVersionIndex - 1].thriveValueVersionID : "";
                        var versionTwo = result.data.response[newestVersionIndex] ? result.data.response[newestVersionIndex].thriveValueVersionID : "";

                        setSelectedVersionOne(versionOne);
                        setSelectedVersionTwo(versionTwo);

                        setVersionsSelectTwo(result.data.response.filter(x => x.thriveValueVersionID != versionOne));
                    }
                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        } else {
            Api.get(`thriveValue/getAllVersionsByModuleAndCompanyAndReportYear?selectedCompanyID=${selectedCompany}&moduleID=${selectedModule}&reportYearID=${twoID}${selectedCultureType != null ? '&cultureTypeID=' + selectedCultureType : ""}&compareYear=${compareYear}`).then((result) => {
                setVersionsSelectTwo(result.data.response);

                if (companyID && reportYearID && operationID && moduleID && moduleID == selectedModule) {
                    if (result.data.response.length > 1) {
                        var newestVersionIndex = (result.data.response.length - 1);
                        var versionOne = result.data.response[newestVersionIndex - 1] ? result.data.response[newestVersionIndex - 1].thriveValueVersionID : "";

                        setSelectedVersionTwo(versionOne);
                    }
                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        }
    }


    const onChangeReportYearTwo = (value) => {
        setSelectedReportYearTwo(value);
        loadVersionsCompareYear(false, value)
    }


    const onChangeVersionOne = (value) => {
        setSelectedVersionTwo(null);
        setSelectedVersionOne(value);
        if ((!compareYear) || (compareYear && selectedReportYearOne == selectedReportYearTwo)) {
            setVersionsSelectTwo(versionsSelectOne.filter(x => x.thriveValueVersionID != value));
        } else if (compareYear && selectedReportYearOne != selectedReportYearTwo) {
            loadVersionsCompareYear(false, selectedReportYearTwo)
        }
    }

    const loadThriveValueByFilter = () => {
        setLoadingView(true);

        if (selectedCompany && selectedModule && selectedVersionOne && selectedVersionTwo) {
            var versionNumberOne = versionsSelectOne.find(x => x.thriveValueVersionID == selectedVersionOne).version;
            var versionNumberTwo = versionsSelectTwo.find(x => x.thriveValueVersionID == selectedVersionTwo).version;

            setSelectedVersionNumberOne(`Version ${compareYear ? versionNumberOne + " (" + cropYears.find(e => e.reportYearID == selectedReportYearOne)?.year + ")" : versionNumberOne}`);
            setSelectedVersionNumberTwo(`Version ${compareYear ? versionNumberTwo + " (" + cropYears.find(e => e.reportYearID == selectedReportYearTwo)?.year + ")" : versionNumberTwo}`);

            Api.get(`thriveValue/GetThriveValueByModuleAndVersions?selectedCompanyID=${selectedCompany}&moduleID=${selectedModule}&versionOneID=${selectedVersionOne}&versionTwoID=${selectedVersionTwo}&showJustInput=${showJustInput}&compareYear=${compareYear}`).then((result) => {
                if (result && result.data) {
                    var specificData = [];
                    var viewDataAux = result.data.response;

                    if (showJustDataChanged) {
                        viewDataAux.versionComparisonList = viewDataAux.versionComparisonList.filter(x => x.valueChanged
                            || x.commentChanged
                            || x.fileChanged);
                    }

                    //Ref Number filter (Select)
                    var refNumbers = viewDataAux.versionComparisonList.filter((thing, i, arr) => {
                        return arr.findIndex(t => t.kpiRefNumber === thing.kpiRefNumber) === i;
                    });

                    viewDataAux.versionComparisonList.map((item) => {
                        item.collapsed = (item.commentOne || item.commentTwo || item.filesOne?.length > 0 || item.filesTwo?.length > 0) ? true : false;
                    });

                    if (selectedModule == 1) {
                        specificData = viewDataAux.versionComparisonList.filter(x => x.kpiRefNumber == "1205");
                        viewDataAux.versionComparisonList = viewDataAux.versionComparisonList.filter(x => x.kpiRefNumber != "1205");
                    }

                    setViewData(viewDataAux);
                    setViewSpecificData(specificData);
                    setRefNumberSelect(refNumbers);
                }

                setSelectedRefNumber(null);
                setLoadingView(false);
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        } else {
            error_message("May you select all filters");
            setLoadingView(false);
        }
    }

    const onChangeRefNumberFilter = (value) => {
        var filter, table, tr, td, i, txtValue;
        filter = value;
        table = document.getElementById("versionTable");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td")[0];
            if (td) {
                txtValue = td.textContent || td.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }

        setSelectedRefNumber(value);
    }

    const getFile = async (fileName) => {
        setLoadingFile(true);

        await Api.get(`ThriveValue/getFile/${fileName}`, { responseType: 'blob' })
            .then(res => {
                let url = window.URL.createObjectURL(res.data);
                window.open(url);
                setLoadingFile(false);
            });
    }

    const collapseFunction = async (collapsed, index) => {
        var newVersionComparisonList = viewData.versionComparisonList;

        newVersionComparisonList[index].collapsed = collapsed;

        setViewData({ ...viewData, versionComparisonList: newVersionComparisonList });
    }

    useEffect(() => {
        if (selectedCompany != null && selectedReportYear != null && selectedOperation != null && selectedModule != null && selectedVersionOne && selectedVersionTwo) {
            if (!isFirstLoading && !compareYear) {
                loadThriveValueByFilter();
                setIsFirstLoading(true);
            }
        }
    }, [selectedCompany, selectedReportYear, selectedOperation, selectedModule]);

    return (
        !loading && userObject ?
            <Container className="container">
                <div className="row mt-2">
                    {
                        userObject && (!userObject.companyID || userObject.groupID) &&
                        <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                            <Select
                                options={companies?.map((c) => ({ value: c.companyID, label: c.name })) ?? []}
                                value={companies?.find((c) => c.companyID === selectedCompany) ? { value: selectedCompany, label: companies.find((c) => c.companyID === selectedCompany).name } : null}
                                onChange={(x) => onChangeCompany(x?.value ?? '')}
                                placeholder="Select a company"
                                isSearchable
                                isClearable={false}
                                styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                classNamePrefix="version-comp-company"
                            />
                        </div>
                    }
                    {
                        !compareYear ?
                            <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                                <Select
                                    options={cropYears?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                                    value={cropYears?.find((y) => y.reportYearID === selectedReportYear) ? { value: selectedReportYear, label: cropYears.find((y) => y.reportYearID === selectedReportYear).year } : null}
                                    onChange={(x) => onChangeCropYear(x?.value ?? '')}
                                    placeholder="Select report year"
                                    isSearchable
                                    isClearable={false}
                                    styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                    classNamePrefix="version-comp-cropyear"
                                />
                            </div>
                            : <></>
                    }
                    {!(userObject.roleID === "E759AB01-E2C8-4D38-BA5F-BA30949FB70F" && userObject.companyID == null) &&
                        <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                            <Select
                                options={operations?.map((o) => ({ value: o.operationID, label: o.description })) ?? []}
                                value={
                                    selectedOperation !== '' && selectedOperation != null && operations?.find((o) => o.operationID == selectedOperation)
                                        ? { value: selectedOperation, label: operations.find((o) => o.operationID == selectedOperation).description }
                                        : null
                                }
                                onChange={(x) => onChangeOperation(x?.value ?? '')}
                                placeholder="Select operation"
                                isSearchable
                                isClearable={false}
                                styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                classNamePrefix="version-comp-operation"
                            />
                        </div>
                    }
                    <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={modulesFiltered?.map((m) => ({ value: m.moduleID, label: m.description })) ?? []}
                            value={modulesFiltered?.find((m) => m.moduleID == selectedModule) ? { value: selectedModule, label: modulesFiltered.find((m) => m.moduleID == selectedModule).description } : null}
                            onChange={(x) => {
                                const moduleID = x?.value ?? '';
                                setSelectedModule(moduleID);
                                if (modulesFiltered?.find((m) => m.moduleID == moduleID)?.moduleExternalID != 15000) {
                                    setSelectedCultureType(null);
                                }
                            }}
                            placeholder="Select a module"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="version-comp-module"
                        />
                    </div>
                    {
                        selectedModule ? modulesFiltered.find(x => x.moduleID == selectedModule)?.moduleExternalID == 15000 &&
                            <div className="col-md-12 mt-2" style={{ width: '100%' }}>
                                <Select
                                    options={cultureTypes?.map((ct) => ({ value: ct.cultureTypeID, label: ct.description })) ?? []}
                                    value={cultureTypes?.find((ct) => ct.cultureTypeID === selectedCultureType) ? { value: selectedCultureType, label: cultureTypes.find((ct) => ct.cultureTypeID === selectedCultureType).description } : null}
                                    onChange={(x) => setSelectedCultureType(x?.value ?? '')}
                                    placeholder="Culture Type"
                                    isSearchable
                                    isClearable={false}
                                    styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                    classNamePrefix="version-comp-culturetype"
                                />
                            </div>
                            :
                            <>
                            </>
                    }
                    {
                        compareYear ?
                            <>
                                <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                                    <Select
                                        options={cropYears?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                                        value={cropYears?.find((y) => y.reportYearID === selectedReportYearOne) ? { value: selectedReportYearOne, label: cropYears.find((y) => y.reportYearID === selectedReportYearOne).year } : null}
                                        onChange={(x) => onChangeCropYearCompareYear(x?.value ?? '')}
                                        placeholder="Report year"
                                        isSearchable
                                        isClearable={false}
                                        styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                        classNamePrefix="version-comp-yearone"
                                    />
                                </div>
                                <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                                    <Select
                                        options={cropYears?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                                        value={cropYears?.find((y) => y.reportYearID === selectedReportYearTwo) ? { value: selectedReportYearTwo, label: cropYears.find((y) => y.reportYearID === selectedReportYearTwo).year } : null}
                                        onChange={(x) => onChangeReportYearTwo(x?.value ?? '')}
                                        isDisabled={selectedVersionOne == null || selectedVersionOne === ''}
                                        placeholder="Report year"
                                        isSearchable
                                        isClearable={false}
                                        styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                        classNamePrefix="version-comp-yeartwo"
                                    />
                                </div>
                            </>
                            : <></>
                    }
                    <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={versionsSelectOne?.map((v) => ({ value: v.thriveValueVersionID, label: `Version ${v.version}` })) ?? []}
                            value={versionsSelectOne?.find((v) => v.thriveValueVersionID === selectedVersionOne) ? { value: selectedVersionOne, label: `Version ${versionsSelectOne.find((v) => v.thriveValueVersionID === selectedVersionOne).version}` } : null}
                            onChange={(x) => onChangeVersionOne(x?.value ?? '')}
                            placeholder="Select a Version"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="version-comp-verone"
                        />
                    </div>
                    <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={versionsSelectTwo?.map((v) => ({ value: v.thriveValueVersionID, label: `Version ${v.version}` })) ?? []}
                            value={versionsSelectTwo?.find((v) => v.thriveValueVersionID === selectedVersionTwo) ? { value: selectedVersionTwo, label: `Version ${versionsSelectTwo.find((v) => v.thriveValueVersionID === selectedVersionTwo).version}` } : null}
                            onChange={(x) => setSelectedVersionTwo(x?.value ?? '')}
                            isDisabled={selectedVersionOne == null || selectedVersionOne === ''}
                            placeholder="Select a Version"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="version-comp-vertwo"
                        />
                    </div>
                    <div className="form-check col-md-12 mt-2">
                        <input className="form-check-input" type="checkbox" id="showJustChanged" onChange={() => setShowJustDataChanged(!showJustDataChanged)} checked={showJustDataChanged ? true : false} />
                        <label className="form-check-label">
                            Show just data changed?
                        </label>
                    </div>
                    <div className="form-check col-md-12 mt-2">
                        <input className="form-check-input" type="checkbox" id="showJustInput" onChange={() => setShowJustInput(!showJustInput)} checked={showJustInput ? true : false} />
                        <label className="form-check-label">
                            Show just inputs?
                        </label>
                    </div>
                    <div className="form-check col-md-12 mt-2">
                        <input className="form-check-input" type="checkbox" id="compareYear" onChange={() => setCompareYear(!compareYear)} checked={compareYear ? true : false} />
                        <label className="form-check-label">
                            Compare years?
                        </label>
                    </div>
                    <button className="col-md-12 apply-btn mt-2" onClick={() => loadThriveValueByFilter()}>Apply</button>
                </div>
                <div className="row">
                    {
                        loadingView ?
                            <div className="mt-2" style={{ padding: 0 }}>
                                <TableLoading />
                            </div>
                            :
                            viewData != null &&
                            <>
                                <div className="mt-2">
                                    <label className="col-md-1">Search</label>
                                    <div id="selectRefNumber" className="col-md-3" style={{ width: '100%' }}>
                                        <Select
                                            options={refNumberSelect?.map((item) => ({ value: item.kpiRefNumber, label: item.kpiRefNumber })) ?? []}
                                            value={refNumberSelect?.find((item) => item.kpiRefNumber === selectedRefNumber) ? { value: selectedRefNumber, label: selectedRefNumber } : null}
                                            onChange={(x) => {
                                                const val = x?.value ?? '';
                                                setSelectedRefNumber(val || null);
                                                onChangeRefNumberFilter(val);
                                            }}
                                            placeholder="Select a KPI Ref Number"
                                            isSearchable
                                            isClearable={false}
                                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                                            classNamePrefix="version-comp-refnumber"
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                        />
                                    </div>
                                </div>
                                <Table className="mt-2">
                                    <thead>
                                        <tr>
                                            <th width="30%">Information</th>
                                            <th width="24%" className="text-center">{selectedVersionNumberOne}</th>
                                            <th width="2%" className="text-center"><FaArrowRight size={15} /></th>
                                            <th width="24%" className="text-center">{selectedVersionNumberTwo}</th>
                                            <th width="20%" className="text-center"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="30%">Date Last Modification</td>
                                            <td width="24%" className="text-center">{viewData.lastModificationDateOne.split(' ')[0]}</td>
                                            <td width="2%" className="text-center"><FaArrowRight size={15} /></td>
                                            <td width="24%" className="text-center">{viewData.lastModificationDateTwo.split(' ')[0]}</td>
                                            <th width="20%" className="text-center"></th>
                                        </tr>
                                        <tr>
                                            <td width="30%">User Last Modification</td>
                                            <td width="24%" className="text-center">{viewData.lastModificationUserOne}</td>
                                            <td width="2%" className="text-center"><FaArrowRight size={15} /></td>
                                            <td width="24%" className="text-center">{viewData.lastModificationUserTwo}</td>
                                            <th width="20%" className="text-center"></th>
                                        </tr>
                                        <tr>
                                            <td width="30%">Status</td>
                                            <td width="24%" className="text-center">{viewData.statusOne}</td>
                                            <td width="2%" className="text-center"><FaArrowRight size={15} /></td>
                                            <td width="24%" className="text-center">{viewData.statusTwo}</td>
                                            <th width="20%" className="text-center"></th>
                                        </tr>
                                    </tbody>
                                </Table>
                                <Table id="versionTable" className="mt-2">
                                    <thead className="sticky-top">
                                        <tr>
                                            <th width="15%">KPI</th>
                                            <th width="15%">Column</th>
                                            <th width="24%" className="text-center">{selectedVersionNumberOne}</th>
                                            <th width="2%" className="text-center"><FaArrowRight size={15} /></th>
                                            <th width="24%" className="text-center">{selectedVersionNumberTwo}</th>
                                            <th width="20%" className="text-center">Variation</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            viewData.versionComparisonList && viewData.versionComparisonList.length > 0 ?
                                                viewData.versionComparisonList.map((item, index) => {
                                                    var unitMeasure = item.unitMeasure;
                                                    var yearChanged = false;
                                                    var variation = null

                                                    if (yearTarget != item.yearNumber) {
                                                        yearTarget = item.yearNumber;
                                                        yearChanged = true;
                                                    }

                                                    if (unitMeasure && (item.unitMeasure.inputType == "decimal" || item.unitMeasure.inputType == "number")) {
                                                        variation = item.valueTwo - item.valueOne
                                                    }

                                                    return <>
                                                        {
                                                            selectedRefNumber == null && selectedOperation == 4 && yearChanged && //Glidepath
                                                            <tr key={`data_subSectionKPI_${item.kpiRefNumber}_${index}`} className="sticky-top">
                                                                <td width="50%">Year</td>
                                                                <td width="24%" className="text-center">
                                                                    {
                                                                        <span className={`${item.valueChanged ? "value-change" : ""}`}>
                                                                            {item.yearNumber}
                                                                        </span>
                                                                    }
                                                                </td>
                                                                <td width="2%" className="text-center"><FaArrowRight size={15} className={`${item.valueChanged ? "value-change" : ""}`} /></td>
                                                                <td width="24%" className="text-center">
                                                                    {
                                                                        <span className={`${item.valueChanged ? "value-change" : ""}`}>
                                                                            {item.yearNumber}
                                                                        </span>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        }
                                                        <tr key={`data_subSectionKPI_${item.kpiRefNumber}_${index}`}
                                                            className={`${(selectedRefNumber == null || selectedRefNumber == "") && (item.kpiRefNumber == "1103" || item.kpiRefNumber == "1201" || item.kpiRefNumber == "2371" || item.kpiRefNumber == "8103" || item.kpiRefNumber == "8134") ? "sticky-top" : ""} ${item.collapse ? "shadow-box" : ""}`}
                                                        >
                                                            {
                                                                selectedRefNumber != null && selectedRefNumber != "" && selectedRefNumber != "1103" && (item.cultureTypeNameOne || item.cultureTypeNameTwo) ?
                                                                    <td width="15%">
                                                                        <span style={{ marginRight: "2px" }} className="badge">{item.cultureTypeNameOne ?? "..."}</span>
                                                                        <FaArrowRight style={{ marginRight: "2px" }} size={10} />
                                                                        <span style={{ marginRight: "2px" }} className="badge">{item.cultureTypeNameTwo ?? "..."}</span>
                                                                        <span>({item.kpiRefNumber}) {item.kpiDescription}</span>
                                                                    </td>
                                                                    :
                                                                    selectedRefNumber != null && selectedRefNumber != "" && selectedRefNumber != "2371" && (item.countryNameOne || item.countryNameTwo) ?
                                                                        <td width="15%">
                                                                            <span style={{ marginRight: "2px" }} className="badge">{item.countryNameOne ?? "..."}</span>
                                                                            <FaArrowRight style={{ marginRight: "2px" }} size={10} />
                                                                            <span style={{ marginRight: "2px" }} className="badge">{item.countryNameTwo ?? "..."}</span>
                                                                            <span>({item.kpiRefNumber}) {item.kpiDescription}</span>
                                                                        </td>
                                                                        :
                                                                        (item.kpiRefNumber == "8103" || item.kpiRefNumber == "8104" || item.kpiRefNumber == "8105" || item.kpiRefNumber == "8106"
                                                                            || item.kpiRefNumber == "8107" || item.kpiRefNumber == "8108" || item.kpiRefNumber == "8109" || item.kpiRefNumber == "8215" || item.kpiRefNumber == "8216") && (item.fuelTypeNameOne || item.fuelTypeNameTwo) ?
                                                                            <td width="15%">
                                                                                <span style={{ marginRight: "2px" }} className="badge">{item.fuelTypeNameOne != null ? (item.fuelTypeNameOne ?? "None") + " - " + (item.curingBarnNameOne ?? "None") : "..."}</span>
                                                                                <FaArrowRight style={{ marginRight: "2px" }} size={10} />
                                                                                <span style={{ marginRight: "2px" }} className="badge">{item.fuelTypeNameTwo != null ? (item.fuelTypeNameTwo ?? "None") + " - " + (item.curingBarnNameTwo ?? "None") : "..."}</span>
                                                                                <span>({item.kpiRefNumber}) {item.kpiDescription}</span>
                                                                            </td>
                                                                            :
                                                                            (item.kpiRefNumber == "8134" || item.kpiRefNumber == "8135" || item.kpiRefNumber == "8136") && (item.fuelTypeNameOne || item.fuelTypeNameTwo) ?
                                                                                <td width="15%">
                                                                                    <span style={{ marginRight: "2px" }} className="badge">{item.fuelTypeNameOne != null ? (item.fuelTypeNameOne ?? "None") : "..."}</span>
                                                                                    <FaArrowRight style={{ marginRight: "2px" }} size={10} />
                                                                                    <span style={{ marginRight: "2px" }} className="badge">{item.fuelTypeNameTwo != null ? (item.fuelTypeNameTwo ?? "None") : "..."}</span>
                                                                                    <span>({item.kpiRefNumber}) {item.kpiDescription}</span>
                                                                                </td>
                                                                                :
                                                                                (item.kpiRefNumber == "8203" || item.kpiRefNumber == "8204" || item.kpiRefNumber == "8205" || item.kpiRefNumber == "8206" || item.kpiRefNumber == "8207") && (item.fertilizerNameOne) ?
                                                                                    <td width="15%">
                                                                                        <span style={{ marginRight: "2px" }} className="badge">{item.fertilizerNameTwo ?? "..."}</span>
                                                                                        <span>({item.kpiRefNumber}) {item.kpiDescription}</span>
                                                                                    </td>
                                                                                    :
                                                                                    selectedRefNumber != null && selectedRefNumber != "" && item.yearNumber != null ?
                                                                                        <td width="15%">
                                                                                            <span style={{ marginRight: "2px" }} className="badge">{item.yearNumber}</span>
                                                                                            <span>({item.kpiRefNumber}) {item.kpiDescription}</span>
                                                                                        </td>
                                                                                        :
                                                                                        <td width="15%">({item.kpiRefNumber}) {item.kpiDescription}</td>
                                                            }
                                                            <td width="15%">{item.titleOfColumn}</td>
                                                            <td width="20%" className="text-center">
                                                                {
                                                                    item.unitMeasure.inputType == "Text" || item.unitMeasure.inputType == "input" || item.unitMeasure.inputType == "selectcustom" || item.unitMeasure.inputType == "selectyn" || item.unitMeasure.inputType == "multiselectcustom" ?
                                                                        <span className={`${item.valueChanged ? "value-change" : ""}`}>
                                                                            {item.kpiRefNumber == "1103" ?
                                                                                item.cultureTypeNameOne
                                                                                :
                                                                                item.kpiRefNumber == "2371" ?
                                                                                    item.countryNameOne
                                                                                    :
                                                                                    item.kpiRefNumber == "8103" || item.kpiRefNumber == "8134" ?
                                                                                        item.fuelTypeNameOne
                                                                                        :
                                                                                        item.kpiRefNumber == "8215" ?
                                                                                            item.curingBarnNameOne
                                                                                            :
                                                                                            item.valueOne
                                                                            }
                                                                        </span>
                                                                        :
                                                                        <NumericFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={item.valueOne}
                                                                            decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                            decimalScale={unitMeasure.decimalPrecision}
                                                                            suffix={item.valueOne != "" ? unitMeasure.suffix : ""}
                                                                            displayType="input"
                                                                            type="text"
                                                                            disabled
                                                                            className={`read-only ${item.valueChanged ? "value-change" : ""}`}
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                            allowLeadingZeros={false}
                                                                            allowEmptyFormatting={true}
                                                                        />
                                                                }
                                                            </td>
                                                            <td width="2%" className="text-center"><FaArrowRight size={15} className={`${item.valueChanged ? "value-change" : ""}`} /></td>
                                                            <td width="20%" className="text-center">
                                                                {
                                                                    item.unitMeasure.inputType == "Text" || item.unitMeasure.inputType == "input" || item.unitMeasure.inputType == "selectcustom" || item.unitMeasure.inputType == "selectyn" || item.unitMeasure.inputType == "multiselectcustom" ?
                                                                        <span className={`${item.valueChanged ? "value-change" : ""}`}>
                                                                            {
                                                                                item.kpiRefNumber == "1103" ?
                                                                                    item.cultureTypeNameTwo
                                                                                    :
                                                                                    item.kpiRefNumber == "2371" ?
                                                                                        item.countryNameTwo
                                                                                        :
                                                                                        item.kpiRefNumber == "8103" || item.kpiRefNumber == "8134" ?
                                                                                            item.fuelTypeNameTwo
                                                                                            :
                                                                                            item.kpiRefNumber == "8215" ?
                                                                                                item.curingBarnNameTwo
                                                                                                :
                                                                                                item.valueTwo
                                                                            }
                                                                        </span>
                                                                        :
                                                                        <NumericFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={item.valueTwo}
                                                                            decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                            decimalScale={unitMeasure.decimalPrecision}
                                                                            suffix={item.valueTwo != "" ? unitMeasure.suffix : ""}
                                                                            displayType="input"
                                                                            type="text"
                                                                            disabled
                                                                            className={`read-only ${item.valueChanged ? "value-change" : ""}`}
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                            allowLeadingZeros={false}
                                                                            allowEmptyFormatting={true}
                                                                        />
                                                                }

                                                            </td>

                                                            <td width="20%" className="text-center">

                                                                {
                                                                    variation ?
                                                                        variation > 0 ?
                                                                            <>
                                                                                <FaArrowUp style={{ marginLeft: "auto" }} color='#4DAE49' className='left' size={12}></FaArrowUp>
                                                                                <NumericFormat
                                                                                    thousandsGroupStyle="thousand"
                                                                                    value={variation}
                                                                                    decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                                    decimalScale={2}
                                                                                    suffix={""}
                                                                                    displayType="input"
                                                                                    type="text"
                                                                                    disabled
                                                                                    className={`read-only-variation value-change`}
                                                                                    style={{ display: "inline-block", color: variation > 0 ? "#4DAE49" : "red" }}
                                                                                    thousandSeparator={true}
                                                                                    allowNegative={true}
                                                                                    allowLeadingZeros={false}
                                                                                    allowEmptyFormatting={true}
                                                                                />
                                                                            </>
                                                                            :
                                                                            <>
                                                                                <FaArrowDown color='red' className='left' size={12}></FaArrowDown>
                                                                                <NumericFormat
                                                                                    thousandsGroupStyle="thousand"
                                                                                    value={variation}
                                                                                    decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                                    decimalScale={2}
                                                                                    suffix={""}
                                                                                    displayType="input"
                                                                                    type="text"
                                                                                    disabled
                                                                                    className={`read-only-variation value-change`}
                                                                                    style={{ display: "inline-block", color: variation > 0 ? "#4DAE49" : "red" }}
                                                                                    thousandSeparator={true}
                                                                                    allowNegative={true}
                                                                                    allowLeadingZeros={false}
                                                                                    allowEmptyFormatting={true}
                                                                                />
                                                                            </>
                                                                        : <></>
                                                                }

                                                                {
                                                                    (item.commentOne || item.commentTwo || item.filesOne?.length > 0 || item.filesTwo?.length > 0) ?
                                                                        item.collapsed ?
                                                                            <FaAngleUp style={{ display: "inline-block" }} size={18} className={`${item.fileChanged || item.commentChanged ? "value-change" : ""}`} onClick={() => collapseFunction(false, index)} />
                                                                            :
                                                                            <FaAngleDown style={{ display: "inline-block" }} size={18} className={`${item.fileChanged || item.commentChanged ? "value-change" : ""}`} onClick={() => collapseFunction(true, index)} />
                                                                        :
                                                                        <></>
                                                                }
                                                            </td>

                                                        </tr>
                                                        {
                                                            (item.commentOne != null || item.commentTwo != null) &&
                                                            <CollapseStyled in={item.collapsed}>
                                                                <tr>
                                                                    <td width="15%">Comment</td>
                                                                    <td width="15%"></td>
                                                                    <td width="24%" className="text-center">
                                                                        <span className={`${item.commentChanged ? "value-change" : ""}`}>
                                                                            {item.commentOne}
                                                                        </span>
                                                                    </td>
                                                                    <td width="2%" className="text-center">
                                                                        <FaArrowRight size={15} className={`${item.commentChanged ? "value-change" : ""}`} />
                                                                    </td>
                                                                    <td width="24%" className="text-center">
                                                                        <span className={`${item.commentChanged ? "value-change" : ""}`}>
                                                                            {item.commentTwo}
                                                                        </span>
                                                                    </td>
                                                                    <td width="20%"></td>
                                                                </tr>
                                                            </CollapseStyled>
                                                        }
                                                        {
                                                            (item.filesOne?.length > 0 || item.filesTwo?.length > 0) &&
                                                            <CollapseStyled in={item.collapsed}>
                                                                <tr>
                                                                    <td width="15%">File</td>
                                                                    <td width="15%"></td>
                                                                    <td width="24%" className="text-center">
                                                                        {item.filesOne?.length > 0 ?
                                                                            item.filesOne.map(e => {


                                                                                return (
                                                                                    <>
                                                                                        {e.file.toLowerCase().includes("docx")
                                                                                            ?
                                                                                            <AiFillFileWord className='file' title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFileWord>
                                                                                            :
                                                                                            e.file.toLowerCase().includes("pdf")
                                                                                                ?
                                                                                                <AiFillFilePdf className='file' title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFilePdf>
                                                                                                :
                                                                                                e.file.toLowerCase().includes("png") || e.file.toLowerCase().includes("jpg") || e.file.toLowerCase().includes("jfif")
                                                                                                    ?
                                                                                                    <AiFillFileImage className='file' title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFileImage>
                                                                                                    :
                                                                                                    e.file.toLowerCase().includes("xlsx")
                                                                                                        ?
                                                                                                        <AiFillFileExcel className='file' title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFileExcel>
                                                                                                        :
                                                                                                        <FaFileAlt className='file' title={e.file} size={25} onClick={() => getFile(e.file)}></FaFileAlt>
                                                                                        }

                                                                                    </>
                                                                                )
                                                                            })
                                                                            : <></>
                                                                        }
                                                                    </td>
                                                                    <td width="2%" className="text-center">
                                                                        <FaArrowRight size={15} className={`${item.fileChanged ? "value-change" : ""}`} /></td>
                                                                    <td width="24%" className="text-center">
                                                                        {item.filesTwo?.length > 0 ?
                                                                            item.filesTwo.map(e => {


                                                                                return (
                                                                                    <>
                                                                                        {e.file.toLowerCase().includes("docx")
                                                                                            ?
                                                                                            <AiFillFileWord title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFileWord>
                                                                                            :
                                                                                            e.file.toLowerCase().includes("pdf")
                                                                                                ?
                                                                                                <AiFillFilePdf title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFilePdf>
                                                                                                :
                                                                                                e.file.toLowerCase().includes("png") || e.file.toLowerCase().includes("jpg") || e.file.toLowerCase().includes("jfif")
                                                                                                    ?
                                                                                                    <AiFillFileImage title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFileImage>
                                                                                                    :
                                                                                                    e.file.toLowerCase().includes("xlsx")
                                                                                                        ?
                                                                                                        <AiFillFileExcel title={e.file} size={25} onClick={() => getFile(e.file)}></AiFillFileExcel>
                                                                                                        :
                                                                                                        <FaFileAlt title={e.file} size={25} onClick={() => getFile(e.file)}></FaFileAlt>
                                                                                        }

                                                                                    </>
                                                                                )
                                                                            })
                                                                            : <></>
                                                                        }
                                                                    </td>
                                                                    <td width="20%"></td>
                                                                </tr>
                                                            </CollapseStyled>
                                                        }
                                                    </>
                                                })
                                                :
                                                <tr><td colSpan="4">Some selected version doesn't have data to show</td></tr>
                                        }
                                        {
                                            viewSpecificData.length > 0 &&
                                            viewSpecificData.map((item, index) => {
                                                var unitMeasure = item.unitMeasure;
                                                var variation = null;

                                                if (unitMeasure && (item.unitMeasure.inputType == "decimal" || item.unitMeasure.inputType == "number")) {
                                                    variation = item.valueTwo - item.valueOne
                                                }


                                                return <tr key={`view_subSectionKPI_${item.kpiRefNumber}_${index}`}>
                                                    <td width="15%">({item.kpiRefNumber}) {item.kpiDescription}</td>
                                                    <td width="15%"></td>
                                                    <td width="24%" className="text-center">
                                                        {
                                                            item.unitMeasure.inputType == "Text" || item.unitMeasure.inputType == "input" || item.unitMeasure.inputType == "selectcustom" || item.unitMeasure.inputType == "selectyn" || item.unitMeasure.inputType == "multiselectcustom" ?
                                                                <span className={`${item.valueChanged ? "value-change" : ""}`}>{item.valueOne}</span>
                                                                :
                                                                <NumericFormat
                                                                    thousandsGroupStyle="thousand"
                                                                    value={item.valueOne}
                                                                    decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                    decimalScale={unitMeasure.decimalPrecision}
                                                                    suffix={item.valueOne != "" ? unitMeasure.suffix : ""}
                                                                    displayType="input"
                                                                    type="text"
                                                                    disabled
                                                                    className={`read-only ${item.valueChanged ? "value-change" : ""}`}
                                                                    thousandSeparator={true}
                                                                    allowNegative={true}
                                                                    allowLeadingZeros={false}
                                                                    allowEmptyFormatting={true}
                                                                />
                                                        }
                                                    </td>
                                                    <td width="1%" className="text-center"><FaArrowRight size={15} className={`${item.valueChanged ? "value-change" : ""}`} /></td>
                                                    <td width="24%" className="text-center">
                                                        {
                                                            item.unitMeasure.inputType == "Text" || item.unitMeasure.inputType == "input" || item.unitMeasure.inputType == "selectcustom" || item.unitMeasure.inputType == "selectyn" || item.unitMeasure.inputType == "multiselectcustom" ?
                                                                <span className={`${item.valueChanged ? "value-change" : ""}`}>{item.valueTwo}</span>
                                                                :
                                                                <NumericFormat
                                                                    thousandsGroupStyle="thousand"
                                                                    value={item.valueTwo}
                                                                    decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                    decimalScale={unitMeasure.decimalPrecision}
                                                                    suffix={item.valueTwo != "" ? unitMeasure.suffix : ""}
                                                                    displayType="input"
                                                                    type="text"
                                                                    disabled
                                                                    className={`read-only ${item.valueChanged ? "value-change" : ""}`}
                                                                    thousandSeparator={true}
                                                                    allowNegative={true}
                                                                    allowLeadingZeros={false}
                                                                    allowEmptyFormatting={true}
                                                                />
                                                        }
                                                    </td>
                                                    <td width="20%" className="text-center">
                                                        {
                                                            variation ?
                                                                variation > 0 ?
                                                                    <>
                                                                        <FaArrowUp style={{ marginLeft: "auto" }} color='#4DAE49' className='left' size={12}></FaArrowUp>
                                                                        <NumericFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={variation}
                                                                            decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                            decimalScale={2}
                                                                            suffix={""}
                                                                            displayType="input"
                                                                            type="text"
                                                                            disabled
                                                                            className={`read-only-variation value-change`}
                                                                            style={{ display: "inline-block", color: variation > 0 ? "#4DAE49" : "red" }}
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                            allowLeadingZeros={false}
                                                                            allowEmptyFormatting={true}
                                                                        />
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <FaArrowDown color='red' className='left' size={12}></FaArrowDown>
                                                                        <NumericFormat
                                                                            thousandsGroupStyle="thousand"
                                                                            value={variation}
                                                                            decimalSeparator={unitMeasure.decimalSeparator != "" ? unitMeasure.decimalSeparator : "."}
                                                                            decimalScale={2}
                                                                            suffix={""}
                                                                            displayType="input"
                                                                            type="text"
                                                                            disabled
                                                                            className={`read-only-variation value-change`}
                                                                            style={{ display: "inline-block", color: variation > 0 ? "#4DAE49" : "red" }}
                                                                            thousandSeparator={true}
                                                                            allowNegative={true}
                                                                            allowLeadingZeros={false}
                                                                            allowEmptyFormatting={true}
                                                                        />
                                                                    </>
                                                                : <></>
                                                        }

                                                        {
                                                            (item.commentOne || item.commentTwo || item.filesOne?.length > 0 || item.filesTwo?.length > 0) ?
                                                                item.collapsed ?
                                                                    <FaAngleUp style={{ display: "inline-block" }} size={18} className={`${item.fileChanged || item.commentChanged ? "value-change" : ""}`} onClick={() => collapseFunction(false, index)} />
                                                                    :
                                                                    <FaAngleDown style={{ display: "inline-block" }} size={18} className={`${item.fileChanged || item.commentChanged ? "value-change" : ""}`} onClick={() => collapseFunction(true, index)} />
                                                                :
                                                                <></>
                                                        }
                                                    </td>
                                                </tr>
                                            })
                                        }
                                    </tbody>
                                </Table>
                            </>
                    }
                </div>
                <ModalLoading open={loadingFile} message={"Loading file..."} />
            </Container >
            :
            <Container className="container mt-4">
                <TableLoading />
            </Container>
    );
}

export default VersionComparison;

